import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import { QueryColumn } from "@barthauer/abc/core/data";
import { DataService, ObjectKeys } from "../services/data.service";
import { AppService } from "../services/app.service";
import { ObjectTypeService } from "../services/object-type.service";
import { FavoritesComponent } from "../shared/favorite/favorites.component";
@Component({
  selector: "ubt-geods-favorite-list",
  templateUrl: "./favorite-list.component.html",
  styleUrls: ["./favorite-list.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class FavoriteListComponent implements OnInit, AfterViewInit {
  @Output() closebtn: EventEmitter<any> = new EventEmitter();
  @ViewChild("favorites",{static: false}) favorites: FavoritesComponent
  ;
  public subProjectColumns: QueryColumn[] = [];
  public appObjectTypesKeys = [];
  public showFavorite: Boolean = false;
  public ObjectTypeNames : Record<string | number, string | number> = {} as any;;

  constructor(
    public dataService: DataService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private appService: AppService,
    private objectTypeService: ObjectTypeService,
  ) {
    
    this.appObjectTypesKeys = [
      objectTypeService.getObjectTypesValue(ObjectKeys.SUBPROJECT).toString(),
      objectTypeService.getObjectTypesValue(ObjectKeys.MEASURE).toString(),
      objectTypeService.getObjectTypesValue(ObjectKeys.MEASURETASK).toString(),
    ];
    this.initObjectTypes();
  }
  ngAfterViewInit(): void {
    this.showFavorite = true;
    this.cdr.detectChanges();
  }
  ngOnInit(): void {}

  initObjectTypes() {
     const entries = [
      { key: "Measure", value: +this.objectTypeService.getObjectTypesValue(ObjectKeys.MEASURE) },
      { key: "MeasureTask", value: +this.objectTypeService.getObjectTypesValue(ObjectKeys.MEASURETASK) },
      { key: "SubProject", value: +this.objectTypeService.getObjectTypesValue(ObjectKeys.SUBPROJECT) }
    ];

    entries.forEach(e => {
      this.ObjectTypeNames[e.key] = e.value;
      this.ObjectTypeNames[e.value] = e.key;
    });
  }

  public itemClicked(event): void {
    switch (event.itemData.ObjectType) {
      case this.objectTypeService.getObjectTypesValue(ObjectKeys.SUBPROJECT):
        localStorage.setItem("subProjectId", event.itemData.ParentId);
        this.router.navigate(["subProjectDetail", event.itemData.ParentId]);
        this.closeFavorites();
        break;
      case this.objectTypeService.getObjectTypesValue(ObjectKeys.MEASURE):
        this.dataService.favoriteMeasureId.next(event.itemData.ParentId);
        this.router.navigate([
          "measureDetail",
          "measures",
          event.itemData.ParentId,
        ]);
        this.closeFavorites();
        break;
      case this.objectTypeService.getObjectTypesValue(ObjectKeys.MEASURETASK):
        const measureTask = this.appService.getMeasureTask();
        if (measureTask?.ParentId) {
          this.router.navigate([
            "measureDetail",
            "measures",
            measureTask.ParentId,
          ]);
        } else {
          this.router.navigate([
            "measureDetail",
            "measures",
            event.itemData.MeasureTaskParentId,
          ]);
        }

        this.closeFavorites();
        break;

      default: {
        this.router.navigateByUrl("");
        this.closeFavorites();
      }
    }
  }
  public openFavorites(): void {
    const favouritesContainer = document.getElementById("favouritesContainer");
    if (favouritesContainer) {
      favouritesContainer.style.width = "500px";
      this.changeFavouriteStyle(["container"], "0.99", "auto");
    }
  }

  public closeFavorites(): void {
    if (document.getElementById("closeFavoritebtn")) {
      document.getElementById("closeFavoritebtn").style.visibility = "hidden";
      document.getElementById("favouritesContainer").style.width = "0";
      this.changeFavouriteStyle(["container"], "1", "auto");
      this.ObjectTypeNames = {};
      this.closebtn.emit();
      this.favorites.islistOpened = false;
    }
  }

  public changeFavouriteStyle(
    listIds: Array<string>,
    opacity: string,
    pointerEvents: string,
  ) {
    listIds.forEach((ids) => {
      const element = document.getElementById(ids);
      if (element) {
        element.style.visibility = "visible";
        element.style.opacity = opacity;
        element.style.pointerEvents = pointerEvents;
      }
    });
  }
}

export enum ObjectTypeNames {
  SubProject = 330001152,
  Measure = 330001131,
  MeasureTask = 330001137,
}